const solana = async () => (await import("./platforms/solana.js")).default;
export default solana;
//# sourceMappingURL=solana.js.map